import JSCookie from 'js-cookie';

import { useUser } from '../store/hooks/users';

export const useAnalyticsParams = () => {
  const user = useUser();

  let url;

  if (typeof document !== 'undefined') {
    url = document.location;
  }

  const cookieGa = JSCookie.get('_ga')?.slice(6);
  const cookieYmUid = JSCookie.get('_ym_uid');

  const cookieUtmz = JSCookie.get('__utmz');
  const __utmzFromParamsArray = [];

  const searchParams = new URLSearchParams(url?.search);
  if (!cookieUtmz && searchParams) {
    const keys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];

    keys.forEach((key) => {
      const value = searchParams.get(key);
      if (value) __utmzFromParamsArray.push(`${key}=${value}`);
    });
  }

  return {
    source: 'recommendation',
    aff_sub: cookieYmUid ? `ga_${cookieGa}|ym_${cookieYmUid}` : `ga_${cookieGa}`,
    aff_sub2: url?.pathname,
    aff_sub3: cookieUtmz ?? __utmzFromParamsArray.join('|'),
    ...(user && { aff_unique1: user?.sub }),
  };
};
